import { useEffect, useState } from 'react';
import './App.css';

const pages = {
  about: 'About',
  blog: 'Blog',
  publications: 'Publications',
};

function getCurrentPage() {
  const page = window.location.hash.replace('#', '');
  return Object.hasOwn(pages, page) ? page : 'about';
}

function App() {
  const [currentPage, setCurrentPage] = useState(getCurrentPage);

  useEffect(() => {
    const handleHashChange = () => setCurrentPage(getCurrentPage());
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const renderPage = () => {
    if (currentPage === 'blog') {
      return <EmptyPage title="Blog" description="Writing will appear here soon." />;
    }

    if (currentPage === 'publications') {
      return <EmptyPage title="Publications" description="Publications will appear here soon." />;
    }

    return <AboutPage />;
  };

  return (
    <div className="page">
      <header className="site-header">
        <a className="brand" href="#about"><span className="brand-mark">HV</span><span><strong>Huy Vu</strong><small>AI Engineer</small></span></a>
        <nav className="site-nav" aria-label="Primary navigation">
          {Object.entries(pages).map(([key, label]) => (
            <a key={key} href={`#${key}`} onClick={() => setCurrentPage(key)} aria-current={currentPage === key ? 'page' : undefined}>{label}</a>
          ))}
          <a className="social-link" href="mailto:vunguyenminhhuy.work@gmail.com">Email</a>
          <a className="social-link" href="https://www.linkedin.com/in/vu-nguyen-minh-huy-9402341b5/" target="_blank" rel="noreferrer">LinkedIn <span aria-hidden="true">↗</span></a>
        </nav>
      </header>

      {renderPage()}

      <footer className="site-footer"><span>© 2026 Huy Vu</span><a href={`#${currentPage}`}>Back to top ↑</a></footer>
    </div>
  );
}

function AboutPage() {
  return (
    <main id="top" className="content">
      <div className="hero-grid">
        <img className="profile-image" src="/my_image.jpg" alt="Huy Vu outdoors in Ho Chi Minh City" />
        <div className="hero-copy">
          <p className="location">Ho Chi Minh City · Vietnam</p>
          <p className="intro">I&apos;m Huy Vu, an AI Engineer who enjoys turning research ideas into reliable systems that solve practical problems.</p>
        </div>
      </div>

      <div className="copy">
        <p>My work has grown from academic research into production engineering, and I am interested in the full journey from understanding a problem and developing a deep-learning model to designing, deploying, and improving a service that people can depend on.</p>
        <p>My knowledge spans several deep learning tasks across computer vision, NLP, automatic speech recognition, text-to-speech, and recommendation systems, but my interest still focuses on 3D reconstruction. I am also increasingly interested in cloud and system design: how to build services that are reliable, maintainable, observable, scalable, and cost-effective.</p>
        <p>The reason for expanding my knowledge horizontally is to make it easier to talk with other people. During my career, I have met a lot of interesting people. Building a foundation across different roles helps me not just have an initial conversation with them, but also learn, empathize, and find opportunities in my field.</p>
      </div>

      <p className="contact-line"><a href="mailto:vunguyenminhhuy.work@gmail.com">vunguyenminhhuy.work@gmail.com ↗</a><span>Ho Chi Minh City · Vietnam</span></p>
    </main>
  );
}

function EmptyPage({ title, description }) {
  return (
    <main id="top" className="content empty-page">
      <p className="location">Huy Vu · AI Engineer</p>
      <h1>{title}</h1>
      <div className="empty-state">
        <p>{description}</p>
      </div>
    </main>
  );
}

export default App;
